/**
 * BYOB checkout progress copy below Add to Cart. v1.0.4
 * Timed cross-fade through steps 0–1; step 2 (final) holds until stop() or navigation.
 * Case: progress sits under Add to Cart in cart-summary (customer focus stays on CTA).
 */
(function () {
  "use strict";

  var root = null;
  var stepTimers = [];
  var finalStepIndex = 2;
  /** Milliseconds on each line before advancing (final step is not auto-advanced past). */
  var STEP_INTERVAL_MS = 1600;

  /**
   * @returns {HTMLElement|null}
   */
  function getRoot() {
    if (!root || !document.contains(root)) {
      root = document.querySelector(".sfs-byob-progress");
    }
    return root;
  }

  function clearTimers() {
    for (var i = 0; i < stepTimers.length; i++) {
      clearTimeout(stepTimers[i]);
    }
    stepTimers = [];
  }

  /**
   * @param {number} index - Zero-based step index matching .sfs-byob-progress__line order.
   */
  function setStep(index) {
    var el = getRoot();
    if (!el) return;

    var lines = el.querySelectorAll(".sfs-byob-progress__line");
    var target = Math.max(0, Math.min(index, lines.length - 1));

    for (var i = 0; i < lines.length; i++) {
      var active = i === target;
      lines[i].classList.toggle("is-active", active);
      lines[i].setAttribute("aria-hidden", active ? "false" : "true");
    }

    el.dataset.step = String(target);

    if (target >= finalStepIndex) {
      clearTimers();
    }
  }

  function scheduleAutoAdvance() {
    clearTimers();

    for (var step = 1; step <= finalStepIndex; step++) {
      (function (targetStep) {
        var timer = setTimeout(function () {
          setStep(targetStep);
        }, STEP_INTERVAL_MS * targetStep);
        stepTimers.push(timer);
      })(step);
    }
  }

  /**
   * Show progress region, first line, and begin timed cross-fades.
   */
  function start() {
    var el = getRoot();
    if (!el) return;

    el.hidden = false;
    el.setAttribute("aria-busy", "true");
    setStep(0);
    scheduleAutoAdvance();
  }

  /**
   * Jump to the final line immediately (e.g. long-running PDF); timers cleared.
   */
  function holdFinalStep() {
    setStep(finalStepIndex);
  }

  /**
   * Hide progress region after error or cancel.
   */
  function stop() {
    clearTimers();
    var el = getRoot();
    if (!el) return;
    el.hidden = true;
    el.removeAttribute("aria-busy");
  }

  window.SfsByobCheckoutProgress = {
    start: start,
    setStep: setStep,
    holdFinalStep: holdFinalStep,
    stop: stop,
  };
})();